import { render, staticRenderFns } from "./BaseCountCardProduct.vue?vue&type=template&id=33d8690a&scoped=true"
import script from "./BaseCountCardProduct.vue?vue&type=script&lang=js"
export * from "./BaseCountCardProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d8690a",
  null
  
)

export default component.exports